import React from "react";
import Tooltip from "../Tooltip";
import GradientSeparator from "../GradientSeparator";

const FormSectionWrapper = ({
  title,
  infoTooltip = null, // New prop for tooltip content
  children,
  showFieldSeparators = false, // New prop to show separators between fields
  borderReset = false,
}) => {
  // If showFieldSeparators is enabled, wrap children and add separators between them
  const renderChildren = () => {
    if (!showFieldSeparators) {
      return children;
    }

    // Convert children to array to handle both single and multiple children
    const childrenArray = React.Children.toArray(children);

    // Add separators after children, but skip:
    // - The separator after the first child (typically Progress)
    // - The separator after the last child (we don't want separator after last field)
    // (we want separators between all fields, not after Progress or after last field)
    return childrenArray.map((child, index) => (
      <React.Fragment key={index}>
        {child}
        {index > 0 && index < childrenArray.length - 1 && (
          <GradientSeparator
            variant="dark"
            marginTop="24px"
            marginBottom="24px"
          />
        )}
      </React.Fragment>
    ));
  };

  return (
    <div
      className={`account-section-wrapper edit-mode ${
        borderReset ? "border-reset" : ""
      }`}
    >
      {title && (
        <div className="section-header">
          <div className="section-title-container">
            <h3 className="section-title">{title}</h3>
            {infoTooltip && <Tooltip content={infoTooltip} />}
          </div>
        </div>
      )}
      <div className="section-content">{renderChildren()}</div>
    </div>
  );
};

export default FormSectionWrapper;
